import { ActivityListTypeEnum } from 'src/models/genericActivityList';
import { NoteListItem } from 'src/models/noteList';

import { Callback } from 'src/util/query/models/Callback';
import { ResultRunTypeBaseRecord } from 'src/util/query/models/ResultRecordBaseType';

import { NoteListCallbackStoreContract } from '../interfaces';

export class GetTheOpenNoteModuleNotesForTheUserCallBack extends Callback<NoteListItem[]> {
	public constructor(
		private readonly store: NoteListCallbackStoreContract,
		private readonly page: number,
		private readonly queryIdentifier: string
	) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.store.setListLoadError();
	};

	successCallbackFunction = (
		successResponse: NoteListItem[],
		baseRecordSuccessResponse?: ResultRunTypeBaseRecord
	): void => {
		if (!this.store.isLatestQueryIdentifier(ActivityListTypeEnum.OPEN, this.queryIdentifier)) {
			return;
		}

		this.store.setOpenNoteList({
			page: this.page,
			payload: successResponse,
			totalCount: Number(baseRecordSuccessResponse?.totalCount ?? 0),
		});
	};
}
